import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M23.5928 23.5739H0.407227L12.0041 0.426147L23.5928 23.5739Z",
  fill: "#F29A34",
  stroke: "#F29A34",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M12.0038 20.6762C12.7055 20.6762 13.2743 20.0809 13.2743 19.3466C13.2743 18.6123 12.7055 18.0171 12.0038 18.0171C11.3022 18.0171 10.7334 18.6123 10.7334 19.3466C10.7334 20.0809 11.3022 20.6762 12.0038 20.6762Z",
  fill: "white"
}), React.createElement("path", {
  d: "M12.0039 9.63074V15.6137",
  stroke: "white",
  strokeWidth: "1.5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: "24",
  height: "24",
  fill: "white"
})))), "IconMessageAlert");